import eventLogApi from '@/api/eventLog';
import getSocketIdRequestTransformer from '@/api/transformers/socketId.request.transformer';
import axios from '@/apiClient';
import axiosWidget from 'axios';
import { asyncRecursive } from '@/utils';
import { ActionContext, GetterTree, MutationTree } from 'vuex';
import { RootState } from '@/store';

interface EventLogState {
  lastEventId: number,
  timerManager: { run: Function, cancel: Function } | null
}

const namespaced: boolean = true;

const state: EventLogState = {
  lastEventId: 0,
  timerManager: null
};

const getters: GetterTree<EventLogState, RootState> = {
  fetchSocketEventsCallback(state, getters, rootState: any) {
    return rootState.user.user
      ? eventLogApi.fetchSocketEventsByLastSocketEventId
      : eventLogApi.fetchSocketEventsByLastSocketEventIdForTV;
  }
};

const actions = {
  async fetchLastEventId({ commit }: ActionContext<EventLogState, RootState>) {
    return axios.get('/event-log/log/last', {
      transformRequest: getSocketIdRequestTransformer,
    })
      .then(({ data }) => {
        commit('setLastEventId', data);
      });
  },
  async fetchLastEventIdByToken({ commit }: ActionContext<EventLogState, RootState>, placeId: string) {
    return axiosWidget.get(`/widget/event-log/log/last/${placeId}`)
      .then(({ data }) => {
        commit('setLastEventId', data);
      });
  },
  async socketConnectError({ commit, dispatch, state, getters }: ActionContext<EventLogState, RootState>) {
    if (state.timerManager === null && state.lastEventId !== 0) {
      const timerManager = asyncRecursive(async () => {
        try {
          const socketEvents = await getters.fetchSocketEventsCallback(
            state.lastEventId,
            window.localStorage.getItem('placeId')
          );

          return dispatch('handleNewEvents', socketEvents);
        } catch (e) {

        }
      }, 5000);

      commit('setTimerManager', timerManager);

      if (null !== state.timerManager) {
        timerManager.run();
      }
    }
  },
  async socketReconnect({ commit, dispatch, state, getters }: ActionContext<EventLogState, RootState>) {
    if (state.timerManager !== null) {
      state.timerManager.cancel();

      commit('setTimerManager', null);
    }

    try {
      const socketEvents = await getters.fetchSocketEventsCallback(
        state.lastEventId,
        window.localStorage.getItem('placeId')
      );

      return dispatch('handleNewEvents', socketEvents);
    } catch (e) {

    }
  },
  handleNewEvents({ commit, dispatch }: ActionContext<EventLogState, RootState>, socketEvents: any[]) {
    if (socketEvents.length > 0) {
      dispatch('handleSocketEvents', socketEvents, { root: true });

      const lastEvent = socketEvents[socketEvents.length - 1];

      commit('setLastEventId', lastEvent.id);
    }
  }
};

const mutations: MutationTree<EventLogState> = {
  setTimerManager(state, timerManager: { run: Function, cancel: Function } | null) {
    state.timerManager = timerManager;
  },
  setLastEventId(state, lastEventId: number | null) {
    if (lastEventId !== null && lastEventId > state.lastEventId) {
      state.lastEventId = lastEventId;
    }
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
